import zod from "zod";

import UObject from "@repo/utils/UObject";
import UType from "@repo/utils/UType";

type UserProperty = UObject.Value<{
  [Category in UserProperty.Category]: UObject.Value<{
    [Name in UserProperty.NameByCategory[Category]]: {
      category: Category;
      name: Name;
      value: UserProperty.Value<Category, Name>;
    };
  }>;
}>;
namespace UserProperty {
  export const validate = {
    dismissals: {
      downloadApp: zod.union([
        zod.object({ nextDisplayAt: zod.number() }),
        zod.object({ downloaded: zod.literal(true) }),
      ]),
      attributionSurvey: zod.boolean(),
    },
    surveys: {
      attribution: zod.object({
        option: zod.string(),
        followup: zod.string(),
      }),
    },
    general: {},
  };
  export type Category = keyof typeof validate;
  export type NameByCategory = {
    [Key in Category]: keyof (typeof validate)[Key];
  };

  export type Value<
    Category extends UserProperty.Category,
    Name extends NameByCategory[Category],
  > = zod.TypeOf<
    UType.Narrow<
      (typeof UserProperty.validate)[Category][Name],
      zod.ZodType<any, any, any>
    >
  >;
}

export default UserProperty;
